import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsSavingsAccountViewEnabled() {
  return useCbhFlag(CbhFeatureFlag.ENABLE_SAVINGS_ACCOUNT_VIEWS, {
    defaultValue: false,
  });
}
